// src/redux/authActions.js
import { deleteToken } from 'firebase/messaging';
import { messaging } from '../../../firebase';
import { clearStore } from '../authSlice';
import { useNavigate } from 'react-router-dom';

export const logoutUser = () => async (dispatch) => {
  
  try {
    const navigate = useNavigate();
    navigate("/auth/login");
    const deleted = await deleteToken(messaging);
    if (deleted) {
      dispatch(clearStore());
      console.log('FCM token deleted successfully');
    } else {
      dispatch(clearStore());
      console.warn('No FCM token to delete');
      dispatch(clearStore());
    }
  } catch (error) {
    dispatch(clearStore());
    console.error('Error deleting FCM token:', error);
  }

};
